export default {
  header: "Downloads",
  illustration:
    "Please download our software components by clicking on the following links:",
};
